export function Brand() {
  return <span className="brand">Loyal<span>QR</span></span>;
}

export function Spinner({ label = 'Loading' }) {
  return <div className="state" role="status"><i className="spinner" /><strong>{label}</strong></div>;
}

export function ErrorState({ error, retry }) {
  const networkError = error?.name === 'TypeError' || /failed to fetch|network/i.test(error?.message || '');
  const message = networkError
    ? 'We can’t connect to LoyalQR right now. Check your connection and try again.'
    : error?.message || 'Please try again.';
  return (
    <div className="state error" role="alert">
      <strong>We couldn’t load this</strong>
      <p>{message}</p>
      {retry && <button className="button secondary" onClick={retry}>Try again</button>}
    </div>
  );
}

export function Badge({ status }) {
  const labels = {
    ready: 'Ready',
    pending: 'Not ready yet',
    redeemed: 'Redeemed',
    expired: 'Expired',
    active: 'Active',
    paused: 'Paused',
    past: 'Past',
    unclaimed: 'Not claimed',
    soon: 'Coming soon',
    locked: 'Locked',
    free: 'Free',
  };
  return <span className={`badge ${status}`}>{labels[status] || status}</span>;
}

export function Field({ label, error, hint, children, className = '' }) {
  return (
    <label className={`field ${className}`}>
      <span>{label}</span>
      {children}
      {hint && <small>{hint}</small>}
      {error && <small className="field-error">{error}</small>}
    </label>
  );
}

export function PageHeader({ title, description, action }) {
  return (
    <header className="page-title">
      <div><h1>{title}</h1>{description && <p>{description}</p>}</div>
      {action}
    </header>
  );
}

export function Icon({ name }) {
  const paths = {
    home: <><path d="M3 11.5 12 4l9 7.5" /><path d="M5.5 10v10h13V10M9 20v-6h6v6" /></>,
    ticket: <><path d="M4 5h16v4a3 3 0 0 0 0 6v4H4v-4a3 3 0 0 0 0-6V5Z" /><path d="M12 8v1m0 3v1m0 3v1" /></>,
    people: <><circle cx="9" cy="8" r="3" /><path d="M3 20c0-4 2-6 6-6s6 2 6 6" /><path d="M16 5.5a3 3 0 0 1 0 5.5m1 3c2.7.5 4 2.5 4 5" /></>,
    network: <><circle cx="6" cy="7" r="2.5" /><circle cx="18" cy="7" r="2.5" /><circle cx="12" cy="17" r="2.5" /><path d="m8.2 8.3 2.5 6.2m5.1-6.2-2.5 6.2M8.5 7h7" /></>,
    scan: <><path d="M4 8V4h4m8 0h4v4m0 8v4h-4M8 20H4v-4" /><path d="M8 12h8" /></>,
    qr: <><path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zm4 0h2v6h-6v-2" /></>,
    chart: <><path d="M4 20V10m6 10V4m6 16v-7m4 7H2" /></>,
    billing: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18M7 15h4" /></>,
    settings: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2h-4V21a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9A1.7 1.7 0 0 0 3 14H2.8v-4H3a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1a1.7 1.7 0 0 0 1.9.3A1.7 1.7 0 0 0 10 3V2.8h4V3a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1h.2v4H21a1.7 1.7 0 0 0-1.6 1Z" /></>,
    menu: <><path d="M4 7h16M4 12h16M4 17h16" /></>,
    close: <><path d="m6 6 12 12M18 6 6 18" /></>,
    desktop: <><rect x="3" y="4" width="18" height="13" rx="2" /><path d="M8 21h8m-4-4v4" /></>,
  };
  return <svg className="icon" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{paths[name]}</svg>;
}
